var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3262",
    "data-name": "Rectangle 3262",
    width: 24,
    height: 24,
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_161",
    "data-name": "Mask Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M14.769,2.769a12,12,0,1,0,12,12A12,12,0,0,0,14.769,2.769ZM13.526,24.981A10.287,10.287,0,0,1,6.941,8.1a11.488,11.488,0,0,1,.117,1.395c-.094,1.373-.23,2.232.574,3.39a5.593,5.593,0,0,1,.542,1.62c.149.511.744.779,1.155,1.094.829.635,1.621,1.374,2.5,1.932.58.369.942.552.772,1.26a4.453,4.453,0,0,1-.469,1.426,2.892,2.892,0,0,0,.482,1.291c.432.432.862.83,1.333,1.218C14.677,23.328,13.874,24.113,13.526,24.981Zm8.516-2.938a10.215,10.215,0,0,1-5.34,2.832,4.273,4.273,0,0,1,1.263-1.694,4.306,4.306,0,0,0,1.136-1.4,9.611,9.611,0,0,1,.784-1.339c.408-.629-1.005-1.577-1.463-1.776A15.1,15.1,0,0,1,15.7,16.966c-.652-.459-1.977.24-2.713-.082a14.182,14.182,0,0,1-2.716-1.866c-.905-.681-.861-1.475-.861-2.48.709.026,1.717-.2,2.187.373.149.18.659.983,1,.7.279-.233-.207-1.168-.3-1.388-.289-.676.658-.939,1.142-1.4.633-.6,1.989-1.536,1.881-1.964S13.965,7.215,13.231,7.4c-.11.029-1.079,1.044-1.266,1.2l.015-.994c0-.209-.391-.424-.373-.559.046-.341,1-.96,1.232-1.232-.166-.1-.73-.588-.9-.518-.414.172-.881.291-1.3.464a2.578,2.578,0,0,0-.039-.412l.812.327.574.681.573.591.5.162.8-.75,2.411-1.293V4.592a10.173,10.173,0,0,1,4.357,1.719c-.232.021-.488.055-.777.092a2.486,2.486,0,0,0-.4-.151c.377.81.77,1.609,1.169,2.408.427.854,1.373,1.77,1.538,2.672.2,1.063.06,2.027.167,3.278a5.6,5.6,0,0,0,1.357,2.571,2.729,2.729,0,0,0,1.061.129,10.228,10.228,0,0,1-2.7,4.734Z",
    transform: "translate(-2.769 -2.769)",
    fill: "#5e5e5e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebGray);
export default __webpack_public_path__ + "static/media/webGray.2c7c9649aa5bc5dcdeaeecf63c9c4c21.svg";
export { ForwardRef as ReactComponent };